import { useAuthState } from '../components/auth/ProtectedRoute';
import apiServiceOld from './api-service-old';
import { DefaultService, OpenAPI } from './generated';

class ApiService extends DefaultService {
  static old = apiServiceOld;
}

export type ApiServiceType = typeof ApiService;

export const useApiService = (needValidToken = true) => {
  const { token } = useAuthState();
  if (needValidToken && !token) {
    console.error('No token');
  }
  OpenAPI.TOKEN = token;
  return ApiService;
};
